import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import axios from "../../../axios";

export const getFloorCategories = () => ({ type: "GET_FLOOR_CATEGORIES" })
export const getFloorCategoriesRequest = () => ({ type: "GET_FLOOR_CATEGORIES_REQUEST" })
export const getFloorCategoriesSuccess = payload => ({ type: "GET_FLOOR_CATEGORIES_SUCCESS", payload })
export const getFloorCategoriesFailed = error => ({ type: "GET_FLOOR_CATEGORIES_FAILED", error })

export function* getFloorCategoriesSaga() {
    yield put(getFloorCategoriesRequest())
    try {
        let { data: payload } = yield call(axios,"/floor_categories")
        yield put(getFloorCategoriesSuccess(payload))
    } catch(err){
        yield put(getFloorCategoriesFailed(err))
    }
}

export default function* floorCategoriesSagaWatcher() {
    yield takeEvery("GET_FLOOR_CATEGORIES", getFloorCategoriesSaga)
}